/**
 * Choosing a spot in the world by clicking on it.
 *
 * For anything in the tools that says where something is: where a teleport
 * lands, most of all. Typing coordinates is how a destination ends up a tile
 * into a wall or out at sea; looking at the place and clicking it is how
 * somebody means it.
 *
 * The game view provides the picking, since it is the one that owns the world
 * and the click; anything in the tools can ask for it through here without
 * being handed a way down to it.
 */

export interface PickedTile {
  tx: number;
  tz: number;
  plane: number;
}

type Picker = (done: (at: PickedTile | null) => void) => void;
type Looker = (tx: number, tz: number) => void;

let picker: Picker | null = null;
let looker: Looker | null = null;

/** The game view says how a spot is picked and how the camera is sent somewhere. */
export function provideTilePicking(pick: Picker | null, look: Looker | null): void {
  picker = pick;
  looker = look;
}

/** Asks for the next click in the world. Nothing comes back if it is called off. */
export function pickTile(done: (at: PickedTile | null) => void): boolean {
  if (!picker) return false;
  picker(done);
  return true;
}

/** Sends the camera to look at a spot. */
export function lookAtTile(tx: number, tz: number): void {
  looker?.(tx, tz);
}
